module.exports = __webpack_public_path__ + "img/recycled-material.5e9f990c.svg";